__turbopack_context__.v({
  "alert": "InlineErrorAlert-module-scss-module__gBTJia__alert",
  "icon": "InlineErrorAlert-module-scss-module__gBTJia__icon",
  "iconGlyph": "InlineErrorAlert-module-scss-module__gBTJia__iconGlyph",
  "list": "InlineErrorAlert-module-scss-module__gBTJia__list",
  "message": "InlineErrorAlert-module-scss-module__gBTJia__message",
});
